import token, { tokenToVars } from '../token';
import Button from './button';

export { Button };
export default tokenToVars(Button, token);
